import { createI18n as _createI18n, I18n } from 'vue-i18n'
import { TENANT_ID_MAP } from '@/utils/index'
import en from './en'
import _ from 'lodash'
import en_micro from './en_micro'
import en_default from './en_default'

export function getMessages (tenantId?: string) {
  let messages = _.merge({}, en)
  if (tenantId === TENANT_ID_MAP.hikvision) {
    messages = _.merge({}, en)
  } else if (tenantId === TENANT_ID_MAP.micro) {
    messages = _.merge({}, en, en_micro)
  } else if (!tenantId) {
    messages = _.merge({}, en, en_default)
  }
  return {
    en: messages
  }
}

type I18nReturnType = I18n<{ en: Record<string, string> } & Record<string, any>, unknown, unknown, false>

function createI18n (messages: Record<string, any>, tenantId: string): I18nReturnType {
  const localeMessage = getMessages(tenantId)
  const newMessages = _.cloneDeep(messages)
  const mergedData = _.merge({}, localeMessage, newMessages) as { en: Record<string, string> }
  for (const key in mergedData.en) {
    const value = mergedData.en[key]
    mergedData.en[key] = value.replace(/\\n|\r/g, '\n').replace(/@/g, "{'@'}")
  }
  return _createI18n({
    locale: 'en',
    messages: mergedData,
    globalInjection: true,
    legacy: false,
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    silentFallbackWarn: true
  })
}

export default createI18n
